import { Ref } from 'react';
import { OrderStatistics } from '@api/shipping-data/types/OrderStatistics';
import { ItemStats } from '@api/shipping-data/types/ItemStats';
import { GridEmpty } from 'components/global/GridElements';
import { OrderStatus } from '@pages/orders/detail/tabs-pages/basic-overview/OrderStatus';
import GridHeader from '@pages/orders/detail/tabs-pages/basic-overview/material-grids/GridHeader';
import GridRow from '@pages/orders/detail/tabs-pages/basic-overview/material-grids/GridRow';



interface GridProps {
	orderStatistics: OrderStatistics,
	orderClientId: string,
	deliveryClientId: string | null,
	shipmentClientId: string | null,
	materials: ItemStats[],
	isSameAsSelectedOrder: boolean,
	getMaterialGridOrder: () => void,
	hasClickPermission: boolean,
	ref: Ref<HTMLDivElement | null>,
}


export const Grid = (props: GridProps) => {
	const { orderStatistics, orderClientId, deliveryClientId, shipmentClientId, materials, isSameAsSelectedOrder, getMaterialGridOrder, hasClickPermission, ref } = props;
	
	const isSeparatedOrder = materials ? materials.some(x => x.orderReasonCodes.some(y => y === 'sap_Z1')) : false;

	if (!materials || materials.length === 0) return (
		<div className='detail-materials-element' ref={ref}>

			<p className='grid-title'>
				<span
					className={hasClickPermission ? 'type-link' : ''}
					onClick={() => hasClickPermission ? getMaterialGridOrder() : {}}>
						{`OBJ ${orderClientId}`}
				</span>
				{deliveryClientId && ` - DEL ${deliveryClientId}`}
				{shipmentClientId && ` - SHP ${shipmentClientId}`}
				{isSeparatedOrder && <span className='separated-order'> (rozdělená objednávka)</span>}
			</p>

			<OrderStatus orderStatistics={orderStatistics} />

			<div className={`app-grid detail-materials-grid${isSameAsSelectedOrder ? ' highlighted' : ''}`}>
				<GridHeader />
				<GridEmpty headersLength={4} />
			</div>
		
		</div>
	);

	
	return (
		<div className='detail-materials-element' ref={ref}>

			<div className='materials-header'>
				<p className='grid-title'>
					<span
						className={hasClickPermission ? 'type-link' : ''}
						onClick={() => hasClickPermission ? getMaterialGridOrder() : {}}>
							{`OBJ ${orderClientId}`}
					</span>
					{deliveryClientId && ` - DEL ${deliveryClientId}`}
					{shipmentClientId && ` - SHP ${shipmentClientId}`}
					{isSeparatedOrder && <span className='separated-order'> (rozdělená objednávka)</span>}
				</p>

				<OrderStatus orderStatistics={orderStatistics} />
			</div>

			<div className={`app-grid detail-materials-grid${isSameAsSelectedOrder ? ' highlighted' : ''}`}>
				<GridHeader />
				{materials.map((x,i) =>
					<GridRow
						item={x}
						rowIndex={i}
						key={`order-material-grid-${orderClientId}-${x.materialId}-${x.itemDirection}`} />)}
			</div>

		</div>
	)
}